import { useRouter } from "next/router";

import { FC, MouseEvent } from "react";

import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import CustomButton from "components/CustomButton";

import styles from "./styles";

type BackArrowProps = {
  path?: string;
  label?: string;
  mb?: number;
};

const BackArrow: FC<BackArrowProps> = ({ path, label = "back", mb = 0 }) => {
  const router = useRouter();

  const redirect = (event: MouseEvent<HTMLButtonElement>) => {
    if (!path) {
      event?.preventDefault();
      event?.stopPropagation();
      router.back();
    }
  };

  return (
    <Box display="flex" mb={mb} sx={styles.cursor}>
      <CustomButton
        href={path || ""}
        onClick={redirect}
        link
        sx={styles.button}
      >
        <ArrowBackIcon />{" "}
        <Typography paragraph sx={styles.label} ml={2} mb={0}>
          {label}
        </Typography>
      </CustomButton>
    </Box>
  );
};

export default BackArrow;
